import { rebuildPVDiagram , setTaskDetailVariants} from '@process-advisor/process-miner/processMiner/processMiner';
import { updateVariantSlicerVariantChart } from '@process-advisor/process-miner/api/methods/slicers/updateVariantSlicerVariantChart';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {};

export const showDetailVariants = ({
    eventEmitter,
}: Props) => {
    setTaskDetailVariants();
    updateVariantSlicerVariantChart({ eventEmitter });
    if (apiProvider.getActiveAction() ==='process_miner') rebuildPVDiagram('selectVariantSlicerGridData');

};
